import { Card, Form, Space } from 'antd';
import FormCheckbox from 'components/form/FormCheckbox';
import { RestInputContext } from 'components/form/RestInputContext';
import { get } from 'lodash';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export default function Configurations() {
  const { t } = useTranslation();
  const { form } = useContext(RestInputContext);

  return (
    <Card title={t('mores.locations.configurations.title')}>
      <Space direction="vertical" size={19}>
        <FormCheckbox noStyle name="isActive">
          {t('mores.locations.configurations.active')}
        </FormCheckbox>
        <FormCheckbox noStyle name="isStore">
          {t('mores.locations.configurations.isStore')}
        </FormCheckbox>
        <FormCheckbox
          noStyle
          name="isOrderProcess"
          getValueFromEvent={(e) => {
            if (e.target.checked) {
              form.setFieldsValue({
                isSyncStock: false,
              });
            }
            return e.target.checked;
          }}
        >
          {t('mores.locations.configurations.orderProcessingWarehouse')}
        </FormCheckbox>
        <Form.Item
          noStyle
          shouldUpdate={(p, c) =>
            get(p, 'isOrderProcess') !== get(c, 'isOrderProcess')
          }
        >
          {({ getFieldValue }) => {
            const isOrderProcess = getFieldValue('isOrderProcess');

            return (
              <FormCheckbox
                noStyle
                name="isSyncStock"
                disabled={isOrderProcess}
              >
                {t('mores.locations.configurations.isSyncStock')}
              </FormCheckbox>
            );
          }}
        </Form.Item>
        <FormCheckbox noStyle name="isTabTryBuy">
          {t('mores.locations.configurations.isTabTryBuy')}
        </FormCheckbox>
      </Space>
    </Card>
  );
}
